import * as THREE from 'three'

export default {
  convertToVector3(obj) {
    if (obj instanceof THREE.Vector3) return obj

    return new THREE.Vector3(obj.x, obj.y, obj.z)
  }
}
